import { useMemo } from 'react';

import { useInstantSearch } from 'react-instantsearch';

import { useI18n } from '@change-corgi/core/react/i18n';

type Result = ModelHookResult<{
	count: number;
	countLocalized: string;
}>;

export function useTotalResultsText(): Result {
	const { results } = useInstantSearch();
	const { localizeNumber } = useI18n();

	return {
		data: {
			count: results.nbHits,
			countLocalized: useMemo(() => localizeNumber(results.nbHits), [results.nbHits, localizeNumber]),
		},
	};
}
